import { LOAD_STEPS_LABELS_SUCCESS } from "../actions/menteesRequestAction";

export default function stepLabelReducer(
    state = {},
    action
) {

    if (action.type === LOAD_STEPS_LABELS_SUCCESS) {
        return action.payload;
    }

    return state;
}